import {
  MUTATION_RESPONSE_RECEIVED,
  QUERY_RESPONSE_RECEIVED,
} from '@web-platform/shared-universal-constants/src/network';
import {
  RADAR_CREATE_SESSIONS,
  RADAR_POLL,
  STREVDA_SLOTS,
} from '@web-platform/shared-universal-types/src/network/requestTypes';
import { isAllowedCreative } from '@web-platform/shared-universal-utils-frontend/src/helpers/adverts';
import {
  isFlightsResponseSuccessAndValid,
  isRadarResponseSuccess,
} from '@web-platform/shared-universal-utils-frontend/src/helpers/flightsResponse';
import {
  generateAdvertIdFromCreative,
  generateAdvertIdFromStrevdaSlot,
} from '@web-platform/shared-universal-utils-frontend/src/helpers/generateAdvertId';
import { isResponseContainFlightsBody } from '@web-platform/shared-universal-utils-frontend/src/helpers/radar/flightsResponse';

import type { RadarCreative } from '@web-platform/shared-universal-types/src/network/endpoints/radar/radarCreativeTypes';
import type { RadarResponsePayloadSuccess } from '@web-platform/shared-universal-types/src/network/endpoints/radar/radarResponsePayloadTypes';
import type { RadarQueryTypes } from '@web-platform/shared-universal-types/src/network/requestTypes';
import type { CurrentAdvertIdsState } from '@web-platform/shared-universal-types/src/redux/acorn/state/flightsDayView/entityCollections/currentAdvertIds';
import type { Action } from '@web-platform/shared-universal-types/src/redux/actions/actions-shared-types';

export const INITIAL_STATE = [];

const getCreatives = (type: RadarQueryTypes, response: RadarResponsePayloadSuccess) => {
  if (!isRadarResponseSuccess(type, response) || !isResponseContainFlightsBody(response)) {
    return [];
  }
  const { creatives = [] } = response.body.itineraries;
  return creatives.filter((creative) => isAllowedCreative(creative));
};

const currentAdvertIdsReducer = (
  state: CurrentAdvertIdsState = INITIAL_STATE,
  action: Action,
): CurrentAdvertIdsState => {
  switch (action.type) {
    case MUTATION_RESPONSE_RECEIVED:
    case QUERY_RESPONSE_RECEIVED: {
      switch (action.payload.type) {
        case RADAR_CREATE_SESSIONS:
        case RADAR_POLL: {
          const { response, type } = action.payload;
          if (!isFlightsResponseSuccessAndValid(type, response)) {
            return state;
          }
          const creatives = getCreatives(type, response);

          return Array.from(
            new Set(
              state.concat(
                creatives.map((creative: RadarCreative) => generateAdvertIdFromCreative(creative)),
              ),
            ),
          );
        }

        case STREVDA_SLOTS: {
          if (action.payload.response.error) {
            return state;
          }

          const { body: slots } = action.payload.response;
          const ids = slots.map(generateAdvertIdFromStrevdaSlot);
          return Array.from(new Set(state.concat(ids)));
        }

        default:
          return state;
      }
    }

    default:
      return state;
  }
};

export default currentAdvertIdsReducer;
export const getAll = (state: CurrentAdvertIdsState) => state;
